import { render, staticRenderFns } from "./MenuComposableOctagonBrick.vue?vue&type=template&id=8f0cd620&scoped=true&"
import script from "./MenuComposableOctagonBrick.vue?vue&type=script&lang=js&"
export * from "./MenuComposableOctagonBrick.vue?vue&type=script&lang=js&"
import style0 from "./MenuComposableOctagonBrick.vue?vue&type=style&index=0&id=8f0cd620&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f0cd620",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8f0cd620')) {
      api.createRecord('8f0cd620', component.options)
    } else {
      api.reload('8f0cd620', component.options)
    }
    module.hot.accept("./MenuComposableOctagonBrick.vue?vue&type=template&id=8f0cd620&scoped=true&", function () {
      api.rerender('8f0cd620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/MenuArea/MenuComposableOctagonBrick.vue"
export default component.exports